const getters = {
  permission_routers: state => state.permission.routers,
  theme: state => state.theme.theme,
  themeInfo: state => state.theme.themeInfo,
  isCollapse: state => state.theme.isCollapse,
  userInfo: state => state.user.userInfo,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  uploadUrl: state => state.setting.uploadUrl,
  trainDefaultImg: state => state.setting.trainDefaultImg,
  taskType: state => state.task.taskType
};
export default getters;
